export const animals = state => {
    return state.animals;
}